var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiStarsDisabled = function SvgAiStarsDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E6EC",
    d: "m6.078 11.178 1.11 1.634 1.635 1.11-1.635 1.111-1.11 1.635-1.11-1.635-1.635-1.11 1.635-1.11 1.11-1.635Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D8E2",
    d: "m11.96 3.334 1.272 3.435 3.435 1.27-3.435 1.272-1.271 3.435L10.69 9.31 7.255 8.04l3.435-1.271 1.27-3.435Z"
  })));
};
export default SvgAiStarsDisabled;